module.exports = __webpack_public_path__ + "static/media/Shreeya_Ganji.3fbf91f5.jpg";